import { useRef } from 'react';

const TAB_ID_STORAGE_KEY = 'session_writer_tab_id';

function getOrCreateTabId() {
  let id = sessionStorage.getItem(TAB_ID_STORAGE_KEY);
  if (!id) {
    id = `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
    sessionStorage.setItem(TAB_ID_STORAGE_KEY, id);
  }
  return id;
}

/**
 * Stable per-tab identifier for session command RPCs (idempotency / logging).
 * Writer lease enforcement is retired server-side; this is not an authority token.
 */
export default function useSessionTabInstanceId() {
  const tabInstanceIdRef = useRef(getOrCreateTabId());
  return tabInstanceIdRef.current;
}
